module.exports = function (bootstrap) {
    bootstrap.directive('medicareRating', function () {
        return {
            restrict: 'A',
            replace: false,
            scope: {
                medicareRating: '=',
                outOf: '=?'
            },
            controller: ['$scope', function ($scope) {
                $scope.outOf = $scope.outOf || 5;
            }],
            link: function (scope, ele) {
                var html = '', i;

                for (i=0;i<scope.outOf;i++) {

                    if ((i < scope.medicareRating) && (scope.medicareRating - i >= 0.7)){
                        html += '<span class="hm-icon icon-certified_ribbon_full"></span>';
                    }

                    else if ((i < scope.medicareRating) && (scope.medicareRating - i >= 0.3)) {
                        html += '<span class="hm-icon icon-certified_ribbon_half"></span>';
                    }

                    else{
                        html += '<span class="hm-icon icon-certified_ribbon_empty"></span>';
                    }
                }

                ele.append(angular.element(html));
            }
        };
    });
};